import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/modules/shared/ui/components/dialog"
import { Button } from "@/modules/shared/ui/components/button"
import { Organization } from "@/modules/organizations/entities/Organization"

interface PendingOrganizationDialogProps {
    organization: Organization | null
    onClose: () => void
}

export function PendingOrganizationDialog({
    organization,
    onClose,
}: PendingOrganizationDialogProps) {
    return (
        <Dialog open={!!organization} onOpenChange={(open) => !open && onClose()}>
            <DialogContent className="sm:max-w-[425px] bg-card">
                <DialogHeader>
                    <DialogTitle>Organisation unavailable</DialogTitle>
                    <DialogDescription className="text-muted-foreground mt-2">
                        {organization?.name} is still pending. Please ensure your
                        subscription is active or contact support for assistance.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="mt-4">
                    <Button variant="outline" onClick={onClose}>Got it</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
